import angular from 'angular';
import uiRouter from 'angular-ui-router';
import detailComponent from './detail.component';

let detailModule = angular.module('detail', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.detail', {
    url: '/detail/:modelName/:id',
    component: 'detail',
    params: {
      id: null,
      modelType: null,
      modelName: null
    }
  });
})

.component('detail', detailComponent)

  .name;

export default detailModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/detail.js